import React, { useState } from 'react'
import { Button, Grid } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import DoneIcon from '@mui/icons-material/Done'
import ReplayIcon from '@mui/icons-material/Replay'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import UploadIcon from '@mui/icons-material/Upload'
import ConfirmModal from '../../../components/ConfirmModal'
import { EOrderStatus } from '../../../types/order'
import {
  IImportByOrdersForm,
  OrderImportLeadFormModal,
} from './OrderImportLeadFormModal'
import { OrderChangeStatusTelesaleFormModal } from './OrderChangeStatusTelesaleFormModal'
import { useUser } from '../../../hooks/useUser'
import { FiRefreshCcw } from 'react-icons/fi'

export interface IOrderMenuSelect {
  wait?: boolean
  success?: boolean
  return?: boolean
  cancel?: boolean
  telesale?: boolean
  include?: boolean
  total?: number
  status: EOrderStatus
  enableButtonActionsTracking?: boolean
  onClick: (status: EOrderStatus) => void
  onClickImport?: (data: IImportByOrdersForm) => void
  onClickTelesale?: (username: string) => void
  onClickTracking?: () => void
}

export const OrderMenuSelect = (props: IOrderMenuSelect) => {
  const [isConfirmModal, setIsConfirmModal] = useState<boolean>(false)
  const [isConfirmTelesaleModal, setIsConfirmTelesaleModal] =
    useState<boolean>(false)
  const [isImportModal, setIsImportModal] = useState<boolean>(false)
  const [status, setStatus] = useState<EOrderStatus>()
  const handleConfirm = () => {
    setIsConfirmModal(false)
    props.onClick(status as EOrderStatus)
  }

  const { merchant } = useUser()

  const titleStatus = () => {
    return 'ยืนยันการทำรายการ'
  }

  const messageStatus = () => {
    return status === EOrderStatus.PENDING
      ? 'คุณต้องการเปลี่ยนสถานะเป็น รอรายการคำสั่งซื้อ  ใช่หรือไม่?'
      : status === EOrderStatus.SUCCESS
        ? 'คุณต้องการเปลี่ยนสถานะเป็น รายการคำสั่งซื้อสำเร็จ  ใช่หรือไม่?'
        : status === EOrderStatus.RETURNED
          ? 'คุณต้องการเปลี่ยนสถานะเป็น รายการตีกลับคำสั่งซื้อ ใช่หรือไม่?'
          : status === EOrderStatus.CANCLELLED
            ? 'คุณต้องการยกเลิก ใช่หรือไม่? (จะไม่สามารถย้ายออเดอร์กลับคืนมาได้)'
            : 'คุณต้องการนำเข้าทะเบียนลูกค้าจากคำสั่งซื้อ ใช่หรือไม่?'
  }

  return (
    <>
      <ConfirmModal
        open={isConfirmModal}
        onClose={() => setIsConfirmModal(false)}
        onConfirm={handleConfirm}
        title={titleStatus()}
        message={messageStatus()}
      />
      <OrderImportLeadFormModal
        isOpen={isImportModal}
        onClose={() => setIsImportModal(false)}
        onSuccess={(data: IImportByOrdersForm) => {
          props.onClickImport && props.onClickImport(data)
        }}
      />
      <OrderChangeStatusTelesaleFormModal
        isOpen={isConfirmTelesaleModal}
        onClose={() => setIsConfirmTelesaleModal(false)}
        onSuccess={(username: string) => {
          props.onClickTelesale && props.onClickTelesale(username)
        }}
      />
      <Grid container spacing={2} mb={2}>
        {[EOrderStatus.TELESALE, EOrderStatus.AI, EOrderStatus.SALEPAGE].includes(props.status) && (
          <Grid item>
            <Button
              variant="contained"
              size="medium"
              startIcon={<AccessTimeIcon />}
              color={'warning'}
              onClick={() => {
                setStatus(EOrderStatus.PENDING)
                setIsConfirmModal(true)
              }}
            >
              รอส่งสินค้า {`(${props.total})`}
            </Button>
          </Grid>
        )}
        {(props.status === EOrderStatus.PENDING ||
          props.status === EOrderStatus.TRACKING) && (
            <Grid item>
              <Button
                variant="contained"
                size="medium"
                startIcon={<DoneIcon />}
                color={'success'}
                onClick={() => {
                  setStatus(EOrderStatus.SUCCESS)
                  setIsConfirmModal(true)
                }}
              >
                สำเร็จ {`(${props.total})`}
              </Button>
            </Grid>
          )}
        {[EOrderStatus.RETURN, EOrderStatus.SUCCESS].includes(props.status) && (
          <Grid item>
            <Button
              variant="contained"
              size="medium"
              startIcon={<ReplayIcon />}
              sx={{ backgroundColor: '#06aed4' }}
              onClick={() => {
                setStatus(EOrderStatus.RETURNED)
                setIsConfirmModal(true)
              }}
            >
              ตีกลับ (รับสินค้าแล้ว) {`(${props.total})`}
            </Button>
          </Grid>
        )}
        {[
          EOrderStatus.PENDING,
          EOrderStatus.TELESALE,
          EOrderStatus.AI,
          EOrderStatus.SALEPAGE,
        ].includes(props.status) && (
            <Grid item>
              <Button
                variant="contained"
                size="medium"
                startIcon={<ClearIcon />}
                color={'error'}
                onClick={() => {
                  setStatus(EOrderStatus.CANCLELLED)
                  setIsConfirmModal(true)
                }}
              >
                ยกเลิก {`(${props.total})`}
              </Button>
            </Grid>
          )}
        {props.status === EOrderStatus.PENDING && (
          <Grid item>
            <Button
              variant="contained"
              size="medium"
              startIcon={<AccessTimeIcon />}
              color={'success'}
              onClick={() => {
                setIsConfirmTelesaleModal(true)
              }}
            >
              รายการคำสั่งซื้อ Telesale {`(${props.total})`}
            </Button>
          </Grid>
        )}
        {![
          EOrderStatus.CANCLELLED,
          EOrderStatus.RETURN,
          EOrderStatus.RETURNED,
        ].includes(props.status) &&
          props.include &&
          merchant.config?.openCRM && (
            <Grid item>
              <Button
                variant="contained"
                size="medium"
                startIcon={<UploadIcon />}
                color={'secondary'}
                onClick={() => {
                  setIsImportModal(true)
                }}
              >
                นำเข้าทะเบียนลูกค้าจากคำสั่งซื้อ {`(${props.total})`}
              </Button>
            </Grid>
          )}
        {props.enableButtonActionsTracking && (
          <Grid item>
            <Button
              variant="contained"
              startIcon={<FiRefreshCcw />}
              color={'warning'}
              size="medium"
              onClick={props.onClickTracking}
            >
              อัพเดตสถานะพัสดุ {`(${props.total})`}
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  )
}
